// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import './DocumentInfo.scss';
import { useTranslation } from 'react-i18next';

import PropertyField from '../PropertyField/PropertyField';

// Importing icons
import supplier_icon from '../../assets/icons/white/delivery.png';
import notes_icon from '../../assets/icons/white/document.png';
import license_plate_icon from '../../assets/icons/white/license_plate.png';
import label_icon from '../../assets/icons/white/label.png';
import weight_icon from '../../assets/icons/white/weight.png';
import magic_wand_icon from '../../assets/icons/white/magic_wand.png';

export default function DocumentInfo({ documentsData, editDocumentField }) {
  const { t } = useTranslation();

  function getDocumentHeader() {
    return (
      <>
        <PropertyField
          icon={notes_icon}
          title={t('property_doc_type')}
          value={documentsData?.type}
          name={'type'}
          type='select'
          handleChange={editDocumentField}
          editable={true}
          options={{
            delivery_slip: t('document_type_delivery_slip'),
            weighing_slip: t('document_type_weighing_slip'),
          }}
        />
        <div className='extraction-status'>
          {documentsData?.processing_status === 'pending' && (
            <img className={`magic-wand-icon processing`} src={magic_wand_icon} />
          )}
          {documentsData?.processing_status === 'pending' ? (
            <p className='processing-status'>{t('scanned_document_extraction_running')}</p>
          ) : documentsData?.processing_status === 'errored' ? (
            <p className='processing-status'>{t('scanned_document_extraction_error')}</p>
          ) : documentsData?.processing_status === 'completed' ? (
            <p className='processing-status'>{t('scanned_document_extraction_success')}</p>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  }

  return (
    <div className='document-info'>
      <div className='document-header'>{getDocumentHeader()}</div>
      <div className='document-properties'>
        <div className='document-header-compact'>{getDocumentHeader()}</div>
        <PropertyField
          icon={notes_icon}
          title={t('property_slip_nr')}
          value={documentsData?.slip_nr}
          name={'slip_nr'}
          type='text'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={supplier_icon}
          title={t('property_supplier_no')}
          value={documentsData?.supplier_nr}
          name={'supplier_nr'}
          type='text'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={supplier_icon}
          title={t('property_supplier_name')}
          value={documentsData?.supplier_name}
          name={'supplier_name'}
          type='text'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={label_icon}
          title={t('property_order_no')}
          value={documentsData?.order_nr}
          name={'order_nr'}
          type='text'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={license_plate_icon}
          title={t('property_license_plate')}
          value={documentsData?.vehicle_nr}
          name={'vehicle_nr'}
          type='text'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={weight_icon}
          title={t('property_weight_first')}
          value={documentsData?.weight_kg_first}
          name={'weight_kg_first'}
          type='number'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={weight_icon}
          title={t('property_weight_second')}
          value={documentsData?.weight_kg_second}
          name={'weight_kg_second'}
          type='number'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={weight_icon}
          title={t('property_weight_netto_1')}
          value={documentsData?.weight_kg_netto_1}
          name={'weight_kg_netto_1'}
          type='number'
          handleChange={editDocumentField}
          editable={true}
        />
        <PropertyField
          icon={weight_icon}
          title={t('property_weight_netto_2')}
          value={documentsData?.weight_kg_netto_2}
          name={'weight_kg_netto_2'}
          type='number'
          handleChange={editDocumentField}
          editable={true}
        />
      </div>
    </div>
  );
}
